import React from "react";

export default class CloseButton extends React.Component {
  render() {
    const { onClick, className = "", style, children } = this.props;
    return (
      <button onClick={onClick} className={`lrp-btn lrp-btn-ghost ${className}`.trim()} style={style}>
        {children || 'Close'}
      </button>
    );
  }
}
